import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';

import 'sass/components/tabs';

export default class Tabs extends Component {

	constructor (props) {
		super(props);
	}

	render () {
		var options = this.props.options;

		if(!this.props.options) {
			return false;
		}

		var listRadios = options.map((option, index) => {
			return (
				<input

					value={option.value}
					onChange={this.props.onChange.bind(this)}
					key={index}
					type="radio"
					name={this.props.tabName}
					id={option.value}
				/>);
		});

		var listOptions = options.map((option, index) => {
			return (
				<label
					key={index}
					className="tab"
					htmlFor={option.value}
				>
					{option.label}
				</label>);
		});

		return (
			<div className={this.props.inputClass}>
				<form name={this.props.name} className="ui-tabs">
					{listRadios}
					{listOptions}
					<span className="underline"/>
				</form>
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./js/components/Tabs.js